import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class FilterInput extends Component {
    onBlur(rawValue) {
        const {rangeLimits} = this.props;

        const value = NumberHelper.prepareInt(rawValue)
            .limitByRange(rangeLimits.getMin(), rangeLimits.getMax(), rangeLimits.getMin(), rangeLimits.getMax())
            .get();

        this.props.dispatch(Action.set('RangeOfOutcomes', value));
    }

    render() {
        const {rangeOfOutcomes, sport, testId} = this.props;
        const value = rangeOfOutcomes.getRangeOfOutcomes(sport);

        return <InputText value={value} keyboard="number" onBlur={::this.onBlur} testId={testId} />;
    }
}

function mapStatesToProps(state) {
    const {rangeOfOutcomes} = state;

    return {
        rangeOfOutcomes,
    };
}

export default connect(mapStatesToProps)(FilterInput);
